import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import authentification from './modules/authentification'
import langage from './modules/langage';
import insight from './modules/insight';
import popup from './modules/popup';
import participant from './modules/participant';

const vuexLocal = new VuexPersistence({
	storage: window.localStorage,
	reducer: state => ({
		authentification: {
			userToken: state.authentification.userToken,
			initSearch: state.authentification.initSearch,
			connectUserID: state.authentification.connectUserID,
			connectUserEmail: state.authentification.connectUserEmail,
			isLogged: state.authentification.isLogged,
		},
		langage: {
			langue: state.langage.langue
		},
	})
})


Vue.use(Vuex);

export default window.store = new Vuex.Store({
	plugins: [vuexLocal.plugin],
	modules: {
		authentification,
		langage,
		popup,
		insight,
		participant,
	}
})